<div>
  <div class="text-center">
    <nz-radio-group [(ngModel)]="tabType" nzButtonStyle="solid" (ngModelChange)="fetchSourceData()">
      <label nz-radio-button nzValue="active">{{ "order.orderbox_active_order" | translate }}</label>
      <label nz-radio-button nzValue="history">{{ "order.orderbox_history_order" | translate }}</label>
    </nz-radio-group>

    <!-- <nz-button-group>
      <button
        nz-button
        [nzType]="taskType ? 'default' : 'primary'"
        (click)="orderTypeChange(0)"
      >
        活跃订单
        {{ "order.orderbox_active_order" | translate }}
      </button>
      <button
        nz-button
        [nzType]="taskType ? 'primary' : 'default'"
        (click)="orderTypeChange(1)"
      >
        历史订单
        {{ "order.orderbox_history_order" | translate }}
      </button>
    </nz-button-group> -->
  </div>
  <nz-spin [nzSpinning]="loading">
    <div class="py-[30px]" *ngIf="displayNotify && tabType === 'active'">
      <nz-alert nzShowIcon nzCloseable [nzMessage]="'order.orderbox_info' | translate"></nz-alert>
      <!-- <div class="icon">
        <img src="/assets/icon/orderbox_info.png" />
      </div>
      <div class="text">
        <p>
          {{ "order.orderbox_info" | translate }}
        </p>
      </div>
      <div class="cancel" (click)="closeNotify()">x</div> -->
    </div>

    <nz-table
      #nzTable
      class="v4-layout-list"
      [nzFrontPagination]="false"
      [nzData]="listOfOrder"
      [nzTotal]="total"
      [(nzPageIndex)]="page"
      [nzPageSize]="pageSize"
      nzPaginationType="small"
      [nzShowTotal]="totalTpl"
      (nzPageIndexChange)="onPageChange($event)"
    >
      <thead>
        <tr>
          <th class="w-[100px]">{{ "reservation.table.column.name" | translate }}</th>
          <th>{{ "reservation.table.column.property" | translate }}</th>
          <th>{{ "reservation.table.column.check" | translate }}</th>
          <th>{{ "reservation.table.column.price" | translate }}</th>
          <th>{{ "reservation.table.column.tags" | translate }}</th>
          <th>{{ "reservation.table.column.other_fee" | translate }}</th>
          <th>{{ "reservation.table.column.book_time" | translate }}</th>
          <th></th>
        </tr>
      </thead>
      <tbody class="v4-layout-list-body">
        <tr
          class="cursor-pointer"
          *ngFor="let row of nzTable.data"
          (click)="onClickReservation(row.reservations?.[0]?.code)"
        >
          <td>
            <div class="flex flex-row items-center">
              <img class="w-7 h-7 rounded-full mr-3" [src]="row?.logos?.color" alt="" />
              <div>
                <div>{{ row?.client?.name }}</div>
                <div>
                  <i nz-icon nzType="team" nzTheme="outline"></i>
                  {{ row?.number_of_guests }}
                </div>
              </div>
            </div>
          </td>

          <td>
            {{ row?.reservations?.[0]?.house?.title }}
          </td>

          <td>
            <div class="checkin-range">
              {{ row?.reservations?.[0]?.check_in | dateformat: ["MD"] }}~{{
                row?.reservations?.[0]?.check_out | dateformat: ["MD"]
              }}
            </div>
            <div
              class="checkin-status"
              [class.wait-stay]="row?.reservations?.[0]?.out_status === 'wait_stay'"
              [class.staying]="row?.reservations?.[0]?.out_status === 'staying'"
              [class.completed]="row?.reservations?.[0]?.out_status === 'completed'"
            >
              {{ "order_status." + row?.reservations?.[0]?.out_status | translate }}
            </div>
          </td>

          <td>
            <div class="v4-layout-text-lines">
              <div class="v4-layout-text-line">
                <span>{{ row?.currency_type | currencyToSymbol }}{{ row?.house_fee?.amount }}</span>
                <span *ngIf="[0, 2].indexOf(row?.settlement?.status) !== -1"
                  >({{ "order.money_cleared" | translate }})</span
                >
                <span *ngIf="row?.settlement?.status === 1">({{ "order.unpaid" | translate }})</span>
              </div>
              <div class="v4-layout-text-line">
                <span>{{ "word.commission" | translate }} {{ row?.commission?.amount }}</span>
                <span>{{ "order.net_fee" | translate }} {{ row?.net_house_fee?.amount }}</span>
              </div>
            </div>
          </td>

          <!-- 标签 -->
          <td>
            <div *ngFor="let item of row.reservations">
              <div class="v4-tag-list">
                <!-- 手工单 -->
                <div class="mr-2 py-1" *ngIf="row.thirdparty_type === 5">
                  <div class="v4-tag handmade">
                    {{ "order.handmade_order" | translate }}
                  </div>
                </div>
                <!-- 小时单  -->
                <div class="mr-2 py-1" *ngIf="row?.reservations?.[0]?.is_hour_reservation">
                  <div class="v4-tag hour">
                    {{ "order_status.hour_reservation" | translate }}
                  </div>
                </div>
                <!-- 冲突单 -->
                <div class="mr-2 py-1" *ngIf="row?.reservations?.[0]?.conflict_label?.is_conflict">
                  <div class="v4-tag conflict">
                    {{ "order.conflict_order" | translate }}
                  </div>
                </div>
                <!-- 门锁 -->
                <div class="mr-2 py-1" *ngIf="row?.reservations?.[0]?.tip_no_lock_password">
                  <div class="v4-tag smart-lock">
                    {{ "order.no_lock_password" | translate }}
                  </div>
                </div>
                <div class="mr-2 py-1" *ngFor="let tag of row?.reservations?.[0]?.reservation_tag">
                  <div class="v4-tag" [style.background]="tag.color">{{ tag.tag_name }}</div>
                </div>
              </div>
            </div>
          </td>

          <!-- 其他收支 -->

          <td>
            <div class="v4-layout-text-lines">
              <div class="v4-layout-text-line">
                + {{ row?.currency_type | currencyToSymbol }} {{ row?.other_income?.amount }}
              </div>
              <div class="v4-layout-text-line">
                - {{ row?.currency_type | currencyToSymbol }} {{ row?.expense?.amount }}
              </div>
            </div>
          </td>

          <!-- booking time -->
          <td>
            <div class="v4-layout-text-lines">
              <div class="v4-layout-text-link">{{ row?.booked_time | dateformat: ["MD", "hm"] }}</div>
              <div class="v4-layout-text-link">{{ row?.creator?.name }}</div>
            </div>
          </td>

          <td (click)="$event.stopPropagation()">
            <div class="mb-1" *ngIf="tabType === 'active'">
              <button
                nz-button
                nzSize="small"
                *ngIf="row.reservations?.[0]?.reservation_box?.is_ignored === 0"
                (click)="ignore(row?.reservations?.[0]?.code, 1)"
              >
                {{ "order.orderbox_ignore" | translate }}
              </button>

              <button
                nz-button
                nzSize="small"
                *ngIf="row.reservations?.[0]?.reservation_box?.is_ignored === 1"
                (click)="ignore(row?.reservations?.[0]?.code, 0)"
              >
                {{ "order.orderbox_recovery_remind" | translate }}
              </button>
            </div>

            <div>
              <button nz-button nzType="primary" nzSize="small" (click)="orderChangeRoom(row?.reservations?.[0]?.code)">
                {{ "order.order_change_house_1" | translate }}
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </nz-table>
    <ng-template #totalTpl>
      {{ "component-page_html_总数" | translate: { number: total } }}
      <!-- {{ total }} items -->
    </ng-template>
  </nz-spin>
</div>

<ng-template #ignoreTemplate>
  <div class="host-ignore">
    <div class="title">
      <i nz-icon nzType="exclamation-circle" nzTheme="outline"></i>
      <p>{{ "warning.order.confirm_ignore_order" | translate }}</p>
    </div>
    <div class="content">
      {{ "warning.order.ignore_order_info" | translate }}
    </div>
    <div class="operate">
      <label nz-checkbox [(ngModel)]="notshowIgnoreModal" (ngModelChange)="showIgnoreModalChange()">
        {{ "word.no_longer_prompt_1" | translate }}
      </label>
      <div class="button">
        <button nz-button (click)="closeIgnoreModal()">
          {{ "word.cancel" | translate }}
        </button>
        <button nz-button style="margin-left: 8px" nzType="primary" (click)="confirmIgnore(ignoreReservationId, 1)">
          {{ "word.confirm" | translate }}
        </button>
      </div>
    </div>
  </div>
</ng-template>
